
import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        id: 'ranking',
        name: 'ranking',
        title: i18n.t('Ranking'),
        width: "50px",
        // titleClass: "text-left",
        // dataClass: "text-right",
        titleClass: "right aligned",
        dataClass: "right aligned",
        // formatter: (data) => {
        //     return 'test' + data;
        // }
    },
    {
        id: 'ch',
        name: 'ch',
        title: i18n.t('Ch.'),
        width: "25px",
        visible: true,
        togglable: true
    },
    {
        id: 'sales_channel',
        name: 'sales_channel',
        title: i18n.t('_Integation.Channel Name'),
        width: "140px",
        visible: true,
        togglable: true
    },
    {
        id: 'orders',
        name: 'orders',
        title: i18n.t('Order'),
        filterable: true,
        togglable: true,
        // formatter: (data) => {
        //     return formatNumber(data.numberOfOrder);
        // }
    },
    {
        id: 'qty',
        name: 'qty',
        title: i18n.t('_Report.QTY'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'amount',
        name: 'amount',
        title: i18n.t('Amount'),
        filterable: true,
        togglable: true,
        titleClass: "text-right",
        dataClass: "text-right",
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'shipping',
        name: 'shipping',
        title: i18n.t('_ReportChannel.Shipping'),
        filterable: true,
        togglable: true,
        titleClass: "text-right",
        dataClass: "text-right",
        formatter: (data) => {
            return formatNumberDigit(data);
        },
    },
    {
        id: 'cod_fee',
        name: 'cod_fee',
        title: i18n.t('COD Fee'),
        filterable: true,
        togglable: true,
        titleClass: "text-right",
        dataClass: "text-right",
        formatter: (data) => {
            return formatNumberDigit(data);
        },
    },
    {
        id: 'discount',
        name: 'discount',
        title: i18n.t('Discount'),
        filterable: true,
        togglable: true,
        titleClass: "text-right",
        dataClass: "text-right",
        formatter: (data) => {
            return formatNumberDigit(data);
        },
    },
    {
        id: 'total_sales',
        name: 'total_sales',
        title: i18n.t('Total Sales'),
        // title: `<span>
        //         ${i18n.t('Total Sales')}
        //         <i class="fa fa-info-circle"
        //         data-bs-toggle="tooltip"
        //         data-bs-placement="top"
        //         data-bs-html="true"
        //         data-bs-sanitize="false"
        //         title="${i18n.t('Total sales are calculated as the total amount from that sales channel plus shipping fees.')}">
        //         </i>
        //     </span>`,
        filterable: true,
        togglable: true,
        titleClass: "text-right",
        dataClass: "text-right",
        formatter: (data) => {
            return formatNumberDigit(data);
        },
    },
];


// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/SaleByChannel_fields.js